import React from "react";
import Head from "next/head";

import ArticleMain from "@/components/help/article-main";
import {
  articleMapping,
  categoryMapping,
  collections,
} from "@/components/help/help-articles-data";
import { ArticleKeys, CategoryKeys } from "@/@types/help/Articles";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const HelpArticlePage = ({ collection, category, article }: any) => {
  return (
    <>
      <Head>
        <title>{seoData.HELP_CENTER.title}</title>
        <SeoMetaData data={seoData.HELP_CENTER} />
      </Head>

      <ArticleMain
        collection={collections.find((c) => c.link === collection) as any}
        category={
          {
            key: category,
            value: categoryMapping[category as CategoryKeys],
          } as any
        }
        article={
          {
            key: article,
            value: articleMapping[article as ArticleKeys],
          } as any
        }
      />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const { collection, category, article } = context.params;

  return {
    props: { collection, category, article }, // will be passed to the page component as props
  };
}

export default HelpArticlePage;
